import _ from 'lodash';
import { useQuery } from '@tanstack/react-query';
import { useApiClient } from 'src/hooks/useApiClient';
import { translateSfAccountsTypes } from 'src/utils/translations';
import { useMemo } from 'react';

export function useAccountTypes() {
	const { apiClient } = useApiClient();

	const { data, isLoading, error, refetch } = useQuery<any[]>({
		queryKey: ['account_types'],
		queryFn: async () => {
			const res = await apiClient.salesforceAccountController.getAccountTypes();
			return res.data;
		},
		enabled: true,
		refetchOnWindowFocus: false,
		retry: false,
	});

	const asSelectOptions = useMemo(() => {
		return (data || []).map((item) => ({
			label: translateSfAccountsTypes(item.Name),
			code: item.Name?.toUpperCase(),
			name: item.Name,
			value: item.Id,
		}));
	}, [data]);

	return {
		salesforceAccountTypes: data,
		accountTypes: asSelectOptions,
		isLoadingAccountTypes: isLoading,
		accountTypesError: error,
		refetchAccountTypes: refetch,
	};
}
